import { render } from "./CurrentQuote.vue?vue&type=template&id=130fdfee&ts=true"
import script from "./CurrentQuote.vue?vue&type=script&lang=ts"
export * from "./CurrentQuote.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__